let locks = 0
let restore: (() => void) | undefined

/** Overflow alone does not stop WebKit scrolling the page when a modal input focuses. */
export function lockIOSPageScroll(): () => void {
  if (locks++ === 0) {
    const body = document.body
    const { scrollX, scrollY } = window
    const previous = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
    }
    body.style.position = 'fixed'
    body.style.top = `-${scrollY}px`
    body.style.left = `-${scrollX}px`
    body.style.right = '0'
    restore = () => {
      Object.assign(body.style, previous)
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' })
    }
  }

  let released = false
  return () => {
    if (released) return
    released = true
    if (--locks === 0) {
      restore?.()
      restore = undefined
    }
  }
}
